module.exports = __webpack_public_path__ + "img/ghana-1.d68efe8e.svg";